module.exports = __webpack_public_path__ + "static/media/when-you-can-start.51546788.svg";